import {
  getFavouriteBooks,
  fetchBooksPending,
  fetchBooksError,
  getFavouriteBooksSuccess,
} from './index';
import { authHeader } from './authActions';
import API from './api';

function getFavourites() {
  return (dispatch) => {
    dispatch(fetchBooksPending());
    API.get('favs', { headers: authHeader() })
      .then((res) => {
        dispatch(getFavouriteBooks(res.data));
        return res.data;
      })
      .catch((error) => {
        dispatch(fetchBooksError(error));
      });
  };
}

function createFav(bookId) {
  return (dispatch) => {
    API.post('favs', { book_id: bookId }, { headers: authHeader() })
      .then((res) => {
        dispatch(getFavouriteBooksSuccess(res.data));
      })
      .catch((error) => {
        dispatch(fetchBooksError(error));
      });
  };
}

export { createFav };
export default getFavourites;
